
import { viewer } from "../content/viewershared/main";
import { common } from "./common";


export const actionsviewer = {

  setTheme: function (theme) {
    let root = document.querySelector(':root');
    if (theme === 'red') {
      root.style.setProperty('--color-primary-lssuite', '#B61918');
      root.style.setProperty('--color-secondary-lssuite', '#E30513');
      root.style.setProperty('--color-menu-principal-item-a', '#dadada');
      root.style.setProperty('--color-menu-principal-select-back', '#4a1414');
      root.style.setProperty('--color-menu-principal-disabled', '#411a0e');
      root.style.setProperty('--color-btn-details-color-on', '#981615');
      root.style.setProperty('--color-btn-details-color-off', '#B61918');
      root.style.setProperty('--color-btn-details-color-border', '#4f0d0c');
      root.style.setProperty('--color-principal-links', '#575756');
      root.style.setProperty('--color-principal-links-hover', '#727272');
      root.style.setProperty('--color-btn-principal-border', '#404040');
      root.style.setProperty('--color-btn-principal-border-hover', '#656565');
      root.style.setProperty('--color-jstree-icon', '#7b7b7a');
      root.style.setProperty('--color-jstree-selected', '#575756');
      root.style.setProperty('--color-login-principal', '#ffffff');
      root.style.setProperty('--color-miniatura-background', '#E30513');
      root.style.setProperty('--color-login-input', '#C8D0D8');
      root.style.setProperty('--color-login-input-border', '#C8D0D8');
      root.style.setProperty('--color-login-input-border-focus', '#ffffff');
      root.style.setProperty('--color-login-input-checkbox', '#9e0b10');
      root.style.setProperty('--color-login-input-checkbox-border', '#fff');
      root.style.setProperty('--color-login-input-error', '#dcd1d1');
      root.style.setProperty('--color-login-msg-error', '#d2d2d2');
      root.style.setProperty('--login-screen', "url('/content/imagens/login/login-tela-red.png')");
    }
    else if (theme === 'orange') {
      root.style.setProperty('--color-primary-lssuite', '#D66F3E');
      root.style.setProperty('--color-secondary-lssuite', '#562C19');
      root.style.setProperty('--color-menu-principal-item-a', '#A5927B');
      root.style.setProperty('--color-menu-principal-select-back', '#381C10');
      root.style.setProperty('--color-menu-principal-disabled', '#411a0e');
      root.style.setProperty('--color-btn-details-color-on', '#9e4e0a');
      root.style.setProperty('--color-btn-details-color-off', '#b76839');
      root.style.setProperty('--color-btn-details-color-border', '#8a450a');
      root.style.setProperty('--color-principal-links', '#D07412');
      root.style.setProperty('--color-principal-links-hover', '#e47f14');
      root.style.setProperty('--color-btn-principal-border', '#a25f37');
      root.style.setProperty('--color-btn-principal-border-hover', '#7d4828');
      root.style.setProperty('--color-jstree-icon', '#A5927B');
      root.style.setProperty('--color-jstree-selected', '#D07412');
      root.style.setProperty('--color-login-principal', '#D07412');
      root.style.setProperty('--color-miniatura-background', '#D07412');
      root.style.setProperty('--color-login-input', '#C8D0D8');
      root.style.setProperty('--color-login-input-border', '#9E9E9E');
      root.style.setProperty('--color-login-input-border-focus', '#D66F3E');
      root.style.setProperty('--color-login-input-checkbox', '#3c1f11');
      root.style.setProperty('--color-login-input-checkbox-border', '#fff');
      root.style.setProperty('--color-login-input-error', '#DC6464');
      root.style.setProperty('--color-login-msg-error', '#ff6161');
      root.style.setProperty('--login-screen', "url('/content/imagens/login/login-tela-orange.png')");
    }
    else {
      root.style.setProperty('--color-primary-lssuite', '#24ADB8');
      root.style.setProperty('--color-secondary-lssuite', '#1B3C5D');
      root.style.setProperty('--color-menu-principal-item-a', '#7D93A8');
      root.style.setProperty('--color-menu-principal-select-back', '#0E2032');
      root.style.setProperty('--color-menu-principal-disabled', '#0E2841');
      root.style.setProperty('--color-btn-details-color-on', '#0A939E');
      root.style.setProperty('--color-btn-details-color-off', '#39aeb7');
      root.style.setProperty('--color-btn-details-color-border', '#0A808A');
      root.style.setProperty('--color-principal-links', '#4284F4');
      root.style.setProperty('--color-principal-links-hover', '#3581FF');
      root.style.setProperty('--color-btn-principal-border', '#3D74D0');
      root.style.setProperty('--color-btn-principal-border-hover', '#2B58A4');
      root.style.setProperty('--color-jstree-icon', '#7D93A8');
      root.style.setProperty('--color-jstree-selected', '#4488D8');
      root.style.setProperty('--color-login-principal', '#83A2C0');
      root.style.setProperty('--color-miniatura-background', '#4284F4');
      root.style.setProperty('--color-login-input', '#C8D0D8');
      root.style.setProperty('--color-login-input-border', '#9E9E9E');
      root.style.setProperty('--color-login-input-border-focus', '#24ADB8');
      root.style.setProperty('--color-login-input-checkbox', '#132941');
      root.style.setProperty('--color-login-input-checkbox-border', '#fff');
      root.style.setProperty('--color-login-input-error', '#DC6464');
      root.style.setProperty('--color-login-msg-error', '#ff6161');
      root.style.setProperty('--login-screen', "url('/content/imagens/login/login-tela.png')");
    }
  },

  resize: function () {
  
      viewer.resize();
  },

  viewer: function () {

      viewer.open();

      window.addEventListener("message", function (event) {
        if (event.origin !== window.location.origin) {
          return;
        }
  
        if (!event.data || !event.data.action) {
          return;
        }
  
        if (event.data.action === "liquidsuite-print-dialog-opening") {
          common.closeLoadingFullPage();
        }
      });

  },
  

};